import '@modern/theme/resellers/active/tokens.css';

import i18n from 'i18next';

import styles from '@/console/host/boot-screen.module.css';

// i18n.t, not useTranslation: a fallback that suspends on a language chunk is blank again.
export const BootLoading = () => (
  <div
    aria-label={i18n.t('common:loading')}
    className={styles.screen}
    role="status"
  >
    <span className={styles.mark} />
  </div>
);
